import {
  AnimationBaseController,
  IAnimationControllerConfiguration,
  Inject,
} from "@denishussar/html5-game-engine";
import { SendLetterLogic } from "../Logic/SendLetterLogic";
import { LetterModel, LetterStateEnum } from "../Models/LetterModel";

export interface ILetterControllerOptions {}

export class CursorController extends AnimationBaseController {
  $model: LetterModel;

  public constructor(
    @Inject private _options: ILetterControllerOptions,
    @Inject private _gameLogic: SendLetterLogic
  ) {
    super("CursorController");
  }

  protected getConfiguration(): IAnimationControllerConfiguration {
    return {
      childControllers: {},
      modelWatch: {
        visible: (visible: boolean) =>
          this.visible = visible
      },
    };
  }

  protected onInitialize(): void {
    this.visible = this.$model.visible
  }

  protected onUpdate(frameRate: number): void {
    this._gameLogic.update(frameRate)
  }

  protected onAnimationEvent(name: string, ...args): void {}
}
